import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { Row, Col } from 'antd';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { useGetFeatureAccess } from 'v2/hooks/useGetFeatureAccess';
import type { FeatureAccessStatus } from 'v2/interfaces/featureAccess';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import AnticipationCard from './AnticipationCard';
import AvailableCard from './AvailableCard';
import FutureCard from './FutureCard';
import TotalCard from './TotalCard';

function CardList() {
  const [hasValueToAnticipate, setHasValueToAnticipate] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [anticipateModal, setAnticipateModal] = useState(false);
  const [loadingTransferAvailable, setLoadingTransferAvailable] = useState(true);

  const { data: featureAccessData, refetch: refetchFeatureAccessData } = useGetFeatureAccess();

  const anticipationAccessData: FeatureAccessStatus = featureAccessData?.anticipation;

  const transferAccessData: FeatureAccessStatus = featureAccessData?.transfer;

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const cannotAntecipate = eduzzAccountsService.verifyUserHasBetaModule('cannot-antecipate');

  const [loadTransferAvailable] = useCallbackObservable(() => {
    setLoadingTransferAvailable(true);
    return financialStatementService.getAvailable().pipe(
      tap(({ data }) => {
        financialStatementService.setCurrentBalance(user?.crossborder ? data.total_origin : data.total);
        setLoadingTransferAvailable(false);
      }),
      catchError(error => {
        toast.error(error);
        setLoadingTransferAvailable(false);
        return of(true);
      })
    );
  }, []);

  const toggleTransferModal = () => setTransferModal(prevState => !prevState);
  const toggleAnticipationModal = () => setAnticipateModal(prevState => !prevState);

  const showAntecipate = !cannotAntecipate;
  const lgSize = showAntecipate ? 6 : 8;

  return (
    <Row id='card-list' className='mb-6' gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={lgSize}>
        <TotalCard />
      </Col>
      <Col xs={24} sm={12} lg={lgSize}>
        <AvailableCard
          isLoading={loadingTransferAvailable}
          modalTransferIsOpen={transferModal}
          hasValueToAnticipate={hasValueToAnticipate}
          transferAccessData={transferAccessData}
          refetchFeatureAccessData={refetchFeatureAccessData}
          fetchData={loadTransferAvailable}
          handleToggleTransferModal={toggleTransferModal}
          handleToggleAnticipateModal={toggleAnticipationModal}
        />
      </Col>
      {showAntecipate && (
        <Col xs={24} sm={12} lg={6}>
          <AnticipationCard
            anticipationAccessData={anticipationAccessData}
            refetchFeatureAccessData={refetchFeatureAccessData}
            modalAnticipateIsOpen={anticipateModal}
            updateTransferAvailable={loadTransferAvailable}
            handleToggleTransferModal={toggleTransferModal}
            handleToggleAnticipateModal={toggleAnticipationModal}
            handleSetHasValueToAnticipate={setHasValueToAnticipate}
          />
        </Col>
      )}
      <Col xs={24} sm={12} lg={lgSize}>
        <FutureCard />
      </Col>
    </Row>
  );
}

export default CardList;
